import React from "react";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { QuoteForm } from "@/components/quote/QuoteForm";
import { BRAND } from "@/config/brand";

export default function RequestQuote() {
    return (
        <div>
            <PageMeta title="Request a Quote — YS Removals" description="Tell us about your move and we’ll come back with a tailored quotation." canonical={`https://${BRAND.domain}/request-a-quote`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section-tight">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Request a Quote" }]} />
                    <h1 className="mt-3 text-4xl sm:text-5xl font-semibold tracking-tight font-heading">Request a Quote</h1>
                    <p className="mt-3 text-white/85 max-w-2xl">Answer a few quick questions and we’ll send back a clear, tailored quotation.</p>
                </div>
            </section>
            <section className="container-ys section">
                <QuoteForm />
            </section>
        </div>
    );
}
